//import React, { useState, useEffect } from "react";
import React, { useState, useEffect, useRef } from "react";
import { OverlayTrigger, Tooltip, Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../CommonCSS/SocietyCSS.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EmployeeKPIEntry = () => {

  const today = new Date().toISOString().split("T")[0];
  const [errors, setErrors] = useState({});

  const [isEditable, setIsEditable] = useState(false);

  const [headerData, setHeaderData] = useState({
    emp_id: "",
    entry_date: today
  });

  const [kpiRows, setKpiRows] = useState([{entry_irn: "", kpi_id: "", kpi_name : "", freq: "", freq_desc: "", emp_rating: "0", emp_rem: ""}]);

  const [manualRows, setManualRows] = useState([
    { irn: "", task_name: "", emp_rem: "" }
  ]);

  const inputRefs = useRef([]);

  /// Load KPIs assigned to employee

  useEffect(() => {
    if (headerData.entry_date) {
      loadEmployeeKpis();
    }
  }, [headerData.entry_date]);

  const loadEmployeeKpis = async () => {

    try {

      setKpiRows([]);
      
      const response = await axios.get(`${BASE_URL}/api/get_Daily_Kpi_Emp_Entry`, {
        params: {
//          emp_id: headerData.emp_id,
          p_Entry_Date: headerData.entry_date
        }
      });

      if (response.data.kpiResponse && response.data.kpiResponse.length > 0) {
        setKpiRows(response.data.kpiResponse);
        setManualRows([{
          irn: response.data.adhocKPI.irn,
          task_name: response.data.adhocKPI.task_name,
          emp_rem: response.data.adhocKPI.emp_rem}]);
      }

    } catch (err) {

      console.error("Error loading KPIs", err);

    }

  };

  // const handleKeyNavigation = (e, rowIndex, colIndex) => {

  //   let newRow = rowIndex;
  //   let newCol = colIndex;

  //   if (newRow < 0 || newCol < 0) return;

  //   switch (e.key) {
  //     case "ArrowUp":
  //       newRow = rowIndex - 1;
  //       break;
  //     case "ArrowDown":
  //       newRow = rowIndex + 1;
  //       break;
  //     // case "ArrowLeft":
  //     //   newCol = colIndex - 1;
  //     //   break;
  //     // case "ArrowRight":
  //     //   newCol = colIndex + 1;
  //     //   break;
  //     case "Enter":
  //       newRow = rowIndex + 1;
  //       break;
  //     default:
  //       return;
  //   }

  //   e.preventDefault();

  //   if (
  //     inputRefs.current[newRow] &&
  //     inputRefs.current[newRow][newCol]
  //   ) {
  //     inputRefs.current[newRow][newCol].focus();
  //   }
  // };

  const handleHeaderChange = (e) => {

    const { name, value } = e.target;

    setHeaderData(prev => ({
      ...prev,
      [name]: value
    }));

  };

  const handleKpiChange = async (index, e) => {

    setErrors({});

    const { name, value } = e.target;
    const updatedRows = [...kpiRows];

    let finalValue = value;

    // if (name === "emp_rating") {
    //   finalValue = value === "" ? "" : Number(value);
    // }

    updatedRows[index][name] = finalValue;

    setKpiRows(updatedRows);

  };

  const handleNew = () => {

    setIsEditable(true);

    setTimeout(() => {
      inputRefs.current[0]?.[0]?.focus();
    }, 100);

  };

  const handleClear = () => {

    if (window.confirm("Clear data?")) {

      setIsEditable(false);

      setHeaderData({
        emp_id: "",
        entry_date: today
      });

      setKpiRows([]);

    }

  };

  const handleSave = async () => {

    let rowErrors = {};
    let errorMessage = "";
    let errorRowIndex = null;

    // for (let index = 0; index < kpiRows.length; index++) {

    //   const row = kpiRows[index];
    //   const remarks = row.emp_rem?.trim();

    //   let errors = {};

    //   if (row.freq === "D") {

    //     if (!remarks) {
    //       errors.emp_rem = true;
    //       errorMessage = `Row ${index + 1}: Remarks is mandatory.`;
    //     }
    //     else if (!remarks) {
    //       errors.emp_rem = true;
    //       errorMessage = `Row ${index + 1}: Remarks not entered`;
    //     }

    //     if (errorMessage) {
    //       errorRowIndex = index;
    //       rowErrors[index] = errors;
    //       break;
    //     }
    //   }

    // }

    // // ✅ If error found
    // if (errorRowIndex !== null) {
    //   setErrors({ rowErrors });
    //   toast.error(errorMessage);
    //   setTimeout(() => {
    //     inputRefs.current[errorRowIndex]?.[0]?.focus();
    //   }, 100);
    //   return;
    // }

    if (!window.confirm("Sure you want to Save the inputs ?")) {
      return;
    }

    try {
      
      await axios.post(`${BASE_URL}/api/save_Daily_Emp_Kpis`, {
        header: headerData,
        details: kpiRows,
        manualrows: manualRows
      });

      toast.success("KPI submitted successfully");
      loadEmployeeKpis();
      setKpiRows([]);
      setManualRows([{ irn: "", task_name: "", emp_rem: "" }]);
      setIsEditable(false);

    } catch (err) {
      console.error(err);
      toast.error("Error saving KPI");
    }

  };

  const removeRow = async (index) => {

    try {

      const updated = [...manualRows];
      updated.splice(index, 1);
      setManualRows(updated);

    } catch (err) {
      toast.error(`Unable to Delete Employee from Template.`);
      console.log(`Technical Error. `, err);
    }

  };

  return (

    <Container fluid className="p-3">

      {/* HEADER */}

      <Card className="mb-3 p-3">

        <Row className="mb-3">
          <Col md={3}>

            <InputGroup>

              <InputGroup.Text style={{ width: "90px" }}> Date
              </InputGroup.Text>

              <input type="date" className="form-control"
                name="entry_date" value={headerData.entry_date}
                max={today} 
                disabled 
                onChange={handleHeaderChange} />

            </InputGroup>

          </Col>

        </Row>

        {/* Buttons */}

        <div className="d-flex justify-content-end gap-2 flex-wrap">

          <Button style={{ width: "130px" }} variant="primary"
            onClick={handleNew} disabled={isEditable} > New
          </Button>

          <Button style={{ width: "130px" }} variant="secondary"
            onClick={handleClear} > Clear
          </Button>

          <Button style={{ width: "130px" }} variant="success"
            onClick={handleSave} disabled={!isEditable} > Save
          </Button>

        </div>

      </Card>

      {/* KPI TABLE USING TEMPLATE */}

      <Card className="p-3">

        <div style={{ minHeight: '220px' }} className="table-wrapper">

          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">

            <thead>

              <tr>
                <th style={{ width: "4%", textAlign: "center" }}>#</th>
                <th style={{ width: "35%", textAlign: "left" }}>KPI</th>
                <th style={{ width: "10%", textAlign: "left" }}>Frequency</th>
                {/* <th style={{ width: "12%", textAlign: "left" }}>Self Rating (0 - 10)</th> */}
                <th style={{ width: "35%", textAlign: "left" }}>Remarks</th>
              </tr>

            </thead>

            <tbody>

              {kpiRows.map((row, index) => (

                <tr key={row.kpi_id}>

                  <td style={{ textAlign: "center" }}>
                    {index + 1}
                  </td>

                  <td style={{ textAlign: "left", whiteSpace: "normal", overflowWrap: "normal", wordBreak: "normal" }}> {row.kpi_name}
                  </td>

                  <td style={{ textAlign: "left" }}> {row.freq_desc}
                  </td>

                  {/* <td style={{ textAlign: "right" }}>
                    <input
                      type="number"
                      min="0"
                      max="10"
                      step="1"
                      className={`form-control ${errors?.rowErrors?.[index]?.emp_rating ? "is-invalid" : ""}`}
                      name="emp_rating"
                      value={row.emp_rating}
                      disabled={!isEditable}
                      style={{ textAlign: "right" }}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "") {
                          handleKpiChange(index, e);
                          return;
                        }
                        const num = Number(value);
                        if (num >= 0 && num <= 10) {
                          handleKpiChange(index, e);
                        }
                      }}
                      ref={(el) => {
                        if (!inputRefs.current[index]) inputRefs.current[index] = [];
                        inputRefs.current[index][0] = el;
                      }}
                      onKeyDown={(e) => handleKeyNavigation(e, index, 0)}
                    />
                  </td> */}

                  <td>

                    <textarea
                      className={`form-control ${errors?.rowErrors?.[index]?.emp_rem ? "is-invalid" : ""}`}
                      //className="form-control"
                      name="emp_rem"
                      value={row.emp_rem}
                      disabled={!isEditable}
                      rows={1}
                      onChange={(e) => handleKpiChange(index, e)}
                      ref={(el) => {
                        if (!inputRefs.current[index]) inputRefs.current[index] = [];
                        inputRefs.current[index][1] = el;
                      }}
                      // onKeyDown={(e) => handleKeyNavigation(e, index, 1)}
                    />

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </Card>

      {/* Manual Task */}
      <Card className="p-3 mt-3">

        <h6 style={{color: "maroon"}}><b> Other Tasks (Adhoc Basis)</b></h6>
        <div style={{ minHeight: '220px' }} className="table-wrapper">

          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">

            {/* <table className="table table-bordered"> */}

            <thead>
              <tr>
                <th style={{ width: "35%" }}>Task Name</th>
                <th style={{ width: "55%" }}>Remarks</th>
                <th style={{ width: "10%" }}></th>
              </tr>
            </thead>

            <tbody>

              {manualRows.map((row, index) => (

                <tr key={index}>

                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={row.task_name}
                      disabled={!isEditable}
                      onChange={(e) => {
                        const updated = [...manualRows];
                        updated[index].task_name = e.target.value;
                        setManualRows(updated);
                      }}
                    />
                  </td>

                  <td>
                    <textarea
                      className="form-control"
                      rows={1}
                      value={row.emp_rem}
                      disabled={!isEditable}
                      onChange={(e) => {
                        const updated = [...manualRows];
                        updated[index].emp_rem = e.target.value;
                        setManualRows(updated);
                      }}
                    />
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {(manualRows.length > 1) && (
                      <Button
                        variant="danger"
                        disabled={!isEditable}
                        size="sm"
                        onClick={() => removeRow(index)}
                      >
                        Delete
                      </Button>
                    )}
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

        {/* <div className="d-flex justify-content-end mt-2">
          <OverlayTrigger placement="bottom"
            overlay={<Tooltip id="add-tooltip" style={{ backgroundColor: "#e9ecef" }}>Add Row</Tooltip>} >
            <Button variant="primary"
              onClick={() => setManualRows([...manualRows, { task_name: "", emp_rem: "" }]) }
              disabled={!isEditable}
              style={{ width: "45px", height: "45px", borderRadius: "50%", padding: "0", fontSize: "30px" }} > +
            </Button>
          </OverlayTrigger>
        </div> */}

      </Card>

    </Container>

  );

};

export default EmployeeKPIEntry;
